import { PASSENGERS_CODE } from '@lib/passengers'

export const JJK_RPN = [756974, 206843]
export const YOUNG_ADULT_CODE = 'YAC'
export const FAMILY_TYPE_CODE = 'PFTY'
export const FREE_SEAT_TYPE_CODE = 'PSER'

export const SORT_ORDER = [
  PASSENGERS_CODE.adult,
  FREE_SEAT_TYPE_CODE,
  YOUNG_ADULT_CODE,
  PASSENGERS_CODE.teen,
  PASSENGERS_CODE.child,
  FAMILY_TYPE_CODE,
]

export const FILTER_MAP: Record<string, (type: Passenger.Type) => boolean> = {
  oneWay: ({ code }) => ![FAMILY_TYPE_CODE].includes(code),
  weekly: ({ code }) => ![FAMILY_TYPE_CODE, FREE_SEAT_TYPE_CODE].includes(code),
  collegeRoutes: ({ code }) => [PASSENGERS_CODE.teen, YOUNG_ADULT_CODE].includes(code),
}

/**
 * Dictionary of college route stops.
 *
 * Updated at https://distribusion.atlassian.net/browse/BUFFER-149
 *
 * Source of truth: https://docs.google.com/spreadsheets/d/1f2zeJw5QBu6qjEmP24BZVGhWi6oYel12seIVlu5uS0w
 */
export const COLLEGE_ROUTES = {
  '736A': new Set([
    'IECARCAL',
    'IECARCAW',
    'IECARCBS',
    'IECSOCAS',
    'IEKIUKIL',
    'IENAANAS',
    'IENAANES',
    'IENAANAT',
    'IENAANAO',
  ]),
  UM06: new Set([
    'IEATYATY',
    'IEATYATD',
    'IEKLAKIL',
    'IEBARBAL',
    'IEKIUKIL',
    'IENAANAT',
    'IESALSAL',
    'IECNECLA',
    'IEMANMAY',
    'IENEWNER',
  ]),
  UM12: new Set([
    'IECARTCI',
    'IECARCAW',
    'IECARCBS',
    'IEKIUKIL',
    'IENAANAT',
    'IESALSAL',
    'IECNECLN',
    'IEMANMAY',
    'IENAANAD',
  ]),
  UM14: new Set([
    'IEPORPOO',
    'IEPORPOA',
    'IEMOTMOU',
    'IEPOAPCU',
    'IEPOAPMS',
    'IEMOSMGS',
    'IEKIDKIA',
    'IEKIDKIR',
    'IENEWNER',
    'IENEWNEB',
    'IENAANAT',
    'IESALSAL',
    'IECNECLN',
    'IEMANMAY',
  ]),
  IW02: new Set([
    'IENEWNEG',
    'IENEWNED',
    'IENEWNEI',
    'IEKIDKIR',
    'IEMOSMON',
    'IEKDAKIL',
    'IEATYATF',
    'IEATYATH',
    'IEBYLBAL',
    'IEARLARL',
    'IECARCBS',
    'IECARCAW',
    'IECARCAL',
  ]),
  IW04: new Set(['IEPOAPCU', 'IEPOAPMS', 'IEMOTMON', 'IEPORPOL', 'IESTYSTR', 'IECARCBS', 'IECARCAW', 'IECARCAL']),
}
